tippy('.tippyCall', {
	placement: 'left',
	arrow: true,
	interactive: true,
	theme: 'liftoff'
})

tippy('.tippyCallRight', {
	placement: 'right',
	arrow: true,
	interactive: true,
	theme: 'liftoff'
})

function hidingTooltipsOnScroll() {
	const poppers = document.querySelectorAll('.tippy-popper')

	for (const popper of poppers) {
		const tooltip = popper._reference._tippy

		if (tooltip.state.visible) {
			tooltip.popperInstance.disableEventListeners()
			tooltip.hide()
		}
	}
}